import router from "@/router";
import jwt_decode from "jwt-decode";
import { default as permissions } from '@/@core/data/permissions';
let token_permissions = [...permissions];
let subscription_id = null;
let token = {};
let tokenKeys = [];
let accessToken = localStorage.getItem("accessToken");
if (accessToken) {
  token = jwt_decode(accessToken);
  subscription_id = token.current_subscription_id;
  if (!!token.permission) {
    tokenKeys = token.permission.length ? token.permission : token_permissions.map(p => p.key);
  }
  else {
    localStorage.clear();
    sessionStorage.clear();
    router.push("/login");
  }
}

export const accessHandling = {
  methods: {
    accessHandling(type, ...fields) {
      if (type == "employee") {
        return fields.some(role => tokenKeys.includes(role));
      }
      if (type == "subscription") {
        return fields.includes(subscription_id);
      }
    },
  },
};
